import type { ReactNode } from 'react'
import './SettingsSection.scss'

interface SettingsSectionProps {
  /** Uppercase section header, e.g. "DARSTELLUNG". */
  title: string
  /**
   * `default`: Überschrift als kleine Großbuchstaben-Zeile, Zeilen ohne Linien.
   * `card`: Überschrift in normaler Schreibung, die Zeilen in einer getönten Karte, durch Linien getrennt
   * (Backups, #158).
   */
  variant?: 'default' | 'card'
  /** Section content — usually a vertical stack of {@link SettingsRow}. */
  children: ReactNode
  className?: string
}

/**
 * Headed block within a Settings page. Title is rendered as an uppercase
 * caption (12px, semibold, muted). Body lays out rows vertically with the
 * spacing the Figma pattern expects.
 */
export function SettingsSection({ title, variant = 'default', children, className }: SettingsSectionProps) {
  const classes = ['settings-section', variant === 'card' && 'settings-section--card', className].filter(Boolean).join(' ')
  return (
    <section className={classes}>
      <header className="settings-section__header">
        <h2 className="settings-section__title">{title}</h2>
      </header>
      <div className="settings-section__body">{children}</div>
    </section>
  )
}
